export const imageCodes = {
    
}

export const titleCodes = {
    title: {
        code: "${merchantId}_tmpl_title_1",
        title: "About Us"
    },

    title1: {
        code: "${merchantId}_tmpl_title_2",
        title: "Our Mission"
    },

    title2: {
        code: "${merchantId}_tmpl_title_3",
        title: "Our Vision"
    },
}
//
export const textCodes = {
    aboutus: {
        code: "${merchantId}_tmpl_text_1",
        text: "Phyo's Handmade is a local brand that empowers artisans and helps people in need in Myanmar. Your purchases support the work of 20+ talented young artisans from different regions of Myanmar. Each of the products is personally created with love. Furthermore, a portion of the proceeds from every sale will be donated to children in need. Every product that you purchase helps make a difference. Help us spread the love to those who need it most. Your support means a lot to us."
    },

    mission: {
        code: "${merchantId}_tmpl_text_2",
        text: "Our mission for this shop is to promote quality handmade products and to provide business to local artisans. To encourage people to value and loce local handmade crafts."
    },

    vission: {
        code: "${merchantId}_tmpl_text_3",
        text: "Our vision for this shop is to design beautiful local handmade crochet products and to continuously provide the best products with the best service possible. Moreover, our main vision is to promote Myanmar handmade crafts to international market."
    },

    vission1: {
        code: "${merchantId}_tmpl_text_4",
        text: "Thank you to all our customers who have been supporting us since day one of our store. We appreaciate all the love and suppoet. We have domated a portion of the proceeds to those in needs. Thank you to everyone for trusting our brand and for your continuous love."
    },

    aboutus3: {
        code: "${merchantId}_tmpl_text_4",
        text: "💛 Her.& Co ဆိုတဲ့ နာမည်လေးအတိုင်း နောက်ပိုင်းမှာ မိန်းကလေး များနဲ့ဆိုင်သော Accessories များ Essential Items များကို ကြိုးစားထုတ်လုပ်သွားမှာ ဖြစ်ပါတယ်ရှင်"
    },

    aboutus4: {
        code: "${merchantId}_tmpl_text_5",
        text: "💌 Her.& Co ရဲ့ အမြတ်ငွေလေးများကို တစ်နိုင်တစ်ပိုင် လိုအပ်သော Donation လေးများမှာလည်းထည့်သွင်း လှူဒါန်းနေပါတယ်ရှင် အားလုံး ဘေးကင်း လုံခြုံပါစေရှင် 💗"
    },
}
export const videoCodes = {
    video1: {
        code: "${merchantId}_tmpl_video_1",
        video: "https://www.youtube.com/embed/Xbqd0mhRM2w"
    }
}